import { type ReactNode } from "react";

import { getModalController, type ModalHandle } from "@monorepo/modal";
import { BaseModalWithLogo } from "@monorepo/ui/modal";

export type ShowGlobalModalParams = {
    message: ReactNode;
    title?: ReactNode;
    actionText?: ReactNode;
};

const DEFAULT_MODAL_ID = "global-modal";

let activeHandle: ModalHandle | null = null;

export const showGlobalModal = ({ message, title, actionText }: ShowGlobalModalParams) => {
    const controller = getModalController();

    if (!controller) {
        return;
    }

    if (activeHandle) {
        controller.close(activeHandle.id);
        activeHandle = null;
    }

    const handleClose = () => {
        if (!activeHandle) {
            return;
        }

        controller.close(activeHandle.id);
        activeHandle = null;
    };

    activeHandle = controller.open(
        () => <BaseModalWithLogo message={message} title={title} actionText={actionText} onActionClick={handleClose} />,
        {
            id: DEFAULT_MODAL_ID,
        }
    );
};
